export default __webpack_public_path__ + "static/media/clearp03.96d09b7d.png";